<template>
  <div class="row">
    <div class="container-fluid">
      <div class="row grid-filter">
        <div class="col-md-4 col-md-offset-4">
          <div class="input-group input-group-lg">
            <span class="input-group-addon bg-white">
              <i class="ti-search"></i>
            </span>
            <input type="text" placeholder="Filter Decrypt Keys" class="form-control bg-white" @input="searchInput">
          </div>
        </div>
      </div>
      <div class="row decryptkey-list">
        <key-card :siteini="decryptKey" v-for="decryptKey in decryptKeys" :key="decryptKey.id"/>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import {mapGetters, mapActions} from 'vuex'
import KeyCard from "./List/KeyCard";

export default {
  components: {KeyCard},
  mounted () {
    this.siteiniFetchEncryptedList();
  },
  data: function () {
    return {
      search: '',
      forms: {
        licenseCreate: {
          email: '',
          password: ''
        }
      },
    }
  },
  computed: {
    ...mapGetters(['getSiteiniEncrypted']),
    decryptKeys: function () {
      let decryptKeys = this.getSiteiniEncrypted;
      if (this.search !== '') {
        const search = this.search.toLowerCase();
        decryptKeys = decryptKeys.filter((siteini) => {
          const name = siteini.site.toLowerCase();
          const country = siteini.country.toLowerCase();
          return name.includes(search) || country.includes(search);
        });
      }
      return decryptKeys;
    }
  },
  methods: {
    ...mapActions(['siteiniFetchEncryptedList']),
    searchInput: _.debounce(function (e) {
      this.search = e.target.value;
    }, 500)
  }
}
</script>
<style>
.input-group-addon.bg-white, .form-control.bg-white {
  background: #fff;
}

.decryptkey-list {
  margin-top: 25px;
}

.decryptkey-list .card-header > div {
  position: relative;
}

.decryptkey-list .card-header > div .label {
  position: absolute;
  right: 0;
  top: 3px;
}

.decryptkey-list .card-header > div .card-title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.card-decrypt-key hr {
  margin: 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/DecryptKey/List.vue